import { render, staticRenderFns } from "./CardInputForm.vue?vue&type=template&id=196f5842&scoped=true"
import script from "./CardInputForm.vue?vue&type=script&lang=js"
export * from "./CardInputForm.vue?vue&type=script&lang=js"
import style0 from "./CardInputForm.vue?vue&type=style&index=0&id=196f5842&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f5842",
  null
  
)

export default component.exports